import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { InterviewService } from '../../services/interview.service';
import { TrainingInterviewResponse } from '../../models/virtual-interview-model';

@Component({
  selector: 'app-vr-trails',
  templateUrl: './vr-trails.component.html',
  styleUrls: ['./vr-trails.component.css'],
})
export class VrTrailsComponent implements OnInit {
  steps: MenuItem[] = [{}, {}];
  attemptIndex: number = 0;
  isPaid: boolean = false;
  interviewId: string = '';
  interviewUploadStatus: string = '';
  sessionsInfo: any[] = [];
  isLoading: boolean = true;

  constructor(
    private router: Router,
    private interviewService: InterviewService
  ) {}

  ngOnInit() {
    this.loadInterviewData();
  }

  loadInterviewData() {
    this.isLoading = true;
    this.interviewService.getTrainingInterview().subscribe({
      next: (response: TrainingInterviewResponse) => {
        if (response.interviewProfileInfo) {
          this.isPaid = response.interviewProfileInfo.isPaid;
          this.interviewUploadStatus = response.interviewProfileInfo.interviewUploadStatus;
          this.sessionsInfo = response.interviewProfileInfo.sessionsInfo || [];
          
          if (response.interviewProfileInfo.interviewId) {
            this.interviewId = response.interviewProfileInfo.interviewId;
          }
          
          const completedSessions = this.sessionsInfo.filter(
            (session) => session.sessionStatus === 'COMPLETED'
          ).length;
          
          this.attemptIndex = completedSessions;
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      }
    });
  }

  startAttempt(index: number) {
    if (!this.isPaid) {
      this.scrollToPaymentSection();
      return;
    }

    if (this.interviewUploadStatus === 'PENDING') {
      alert('Your interview is being processed. Please wait a moment and try again.');
      return;
    }

    if (this.interviewUploadStatus === 'COMPLETED') {
      const session = this.sessionsInfo[index];
      
      if (session && session.sessionId) {
        this.router.navigate(['/virtual-interview-session'], {
          state: {
            sessionId: session.sessionId,
            sessionIndex: index
          }
        });
      } else {
        alert('Unable to start interview. Session not found.');
      }
    }
  }

  scrollToPaymentSection() {
    const paymentSection = document.querySelector('.cv-section');
    if (paymentSection) {
      paymentSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  goToPayment(productKey: string) {
    this.router.navigate(['/payment'], {
      state: {
        productKey: productKey,
        serviceSystemId: this.interviewId,
      },
      queryParams: {
        productKey: productKey,
        serviceSystemId: this.interviewId,
      },
    });
  }

  showViewResult(index: number): boolean {
    const session = this.sessionsInfo[index];
    if (!session) return false;
    
    return (session.sessionStatus === 'COMPLETED' || session.sessionStatus === 'IN_PROGRESS') && 
           session.evaluationStatus === 'COMPLETED';
  }

  isEvaluationPending(index: number): boolean {
    const session = this.sessionsInfo[index];
    if (!session) return false;
    
    return session.sessionStatus === 'COMPLETED' && 
           (session.evaluationStatus === 'PENDING' || 
            session.evaluationStatus === 'IN_PROGRESS' || 
            session.evaluationStatus === 'FAILED');
  }

  getEvaluationMessage(index: number): string {
    const session = this.sessionsInfo[index];
    if (!session) return '';
    
    if (session.evaluationStatus === 'PENDING' || session.evaluationStatus === 'IN_PROGRESS') {
      return 'Your interview is being evaluated. Results will be available within 2 hours.';
    } else if (session.evaluationStatus === 'FAILED') {
      return 'Evaluation failed. Please contact support.';
    }
    return '';
  }

  viewResult(index: number) {
    const session = this.sessionsInfo[index];
    
    if (!session) {
      alert('Session not found.');
      return;
    }

    if (session.evaluationStatus !== 'COMPLETED') {
      if (session.evaluationStatus === 'PENDING' || session.evaluationStatus === 'IN_PROGRESS') {
        alert('Your interview is being evaluated. Results will be available within 2 hours. Please check back later.');
      } else if (session.evaluationStatus === 'FAILED') {
        alert('Evaluation failed. Please contact support.');
      }
      return;
    }

    this.router.navigate(['/virtual-interview-result'], {
      state: {
        sessionId: session.sessionId,
        attemptIndex: index
      }
    });
  }
}